import OrderedSetMultiSelect from 'components/inputs/dropdowns/OrderedSetMultiSelect';
import Immutable, { OrderedSet } from 'immutable';
import React from 'react';
import { Project } from 'records/Project';
import { Punch } from 'records/Punch';

interface Props {
  assignees: Immutable.OrderedSet<string>;
  updatedFields: Immutable.Set<string>;
  project: Project;
  actualPunches: Immutable.Set<Punch>;
  onChange: (updatedAssignees: Immutable.OrderedSet<string>) => void;
}

class Assignees extends React.Component<Props> {
  state = {
    assignees: Immutable.OrderedSet<string>(),
    options: Immutable.OrderedSet<string>(),
  };

  componentDidMount(): void {
    this.getDefaultValues();
  }

  componentDidUpdate(nextProps: {
    assignees: Immutable.OrderedSet<string>;
  }): void {
    if (nextProps.assignees !== this.state.assignees) {
      this.getValues();
    }
  }

  handleChange = (updatedAssignees: Immutable.OrderedSet<string>): void => {
    this.props.onChange(updatedAssignees);
  };

  getDefaultValues = (): void => {
    const { onChange, actualPunches, assignees, project } = this.props;
    const allEmpty = actualPunches.every((p) => p.assignees.isEmpty());
    const allSame = this.allSameAssignees();

    let defaultAssignees: OrderedSet<string>;
    let defaultOptions = project.assignees;

    if (allEmpty) {
      defaultAssignees = OrderedSet<string>();
    } else if (assignees.size > 0) {
      defaultAssignees = assignees;
    } else if (allSame) {
      defaultAssignees = actualPunches
        .flatMap((p) => p.assignees)
        .toOrderedSet();
    } else {
      defaultAssignees = OrderedSet<string>(['Multiple Assignees']);
      defaultOptions = defaultAssignees.merge(project.assignees);
    }

    this.setState({ assignees: defaultAssignees, options: defaultOptions });
    onChange(defaultAssignees);
  };

  getValues = (): void => {
    const { onChange, actualPunches, assignees, project } = this.props;
    const allSame = this.allSameAssignees();

    let updatedAssignees: OrderedSet<string>;
    let updatedOptions = project.assignees;

    if (assignees.size > 0) {
      updatedAssignees = assignees;
      assignees.forEach((a) => {
        if (a.includes('Multiple')) {
          updatedOptions = updatedAssignees.merge(project.assignees);
        }
      });
    } else if (allSame) {
      updatedAssignees = actualPunches
        .flatMap((p) => p.assignees)
        .toOrderedSet();
    } else {
      updatedAssignees = OrderedSet<string>();
    }

    this.setState({ assignees: updatedAssignees, options: updatedOptions });
    onChange(updatedAssignees);
  };

  allSameAssignees = (): boolean => {
    const { actualPunches } = this.props;
    const refSet = actualPunches.first<Punch>().assignees;
    return actualPunches.every((p) => {
      if (refSet.size !== p.assignees.size) return false;
      for (const a of refSet) if (!p.assignees.has(a)) return false;
      return true;
    });
  };

  render(): React.ReactNode {
    return (
      <div className="mb4">
        <>
          <OrderedSetMultiSelect
            id="update-multi-punch-overlay-assignees"
            values={this.state.assignees}
            options={this.state.options}
            onChange={this.handleChange}
            placeholder="Select..."
          />
        </>
      </div>
    );
  }
}

export default Assignees;
